import { Fragment, useEffect, useRef, useState } from "react";
import "./add-profession-post.css";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import paper from "../../../assets/paper.png";
import Avatar from "../../../assets/profile-pic.jpeg";
import Offer from "../../../assets/offer.jpeg";
import offerInactive from "../../../assets/offerinactive.jpeg"
import { setHours, setMinutes, setSeconds } from 'date-fns';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import ProfessionalPageApiService from "../../../data/api/services/professional-page/professional-page-api-service";
import { toast } from "react-toastify";
import FormFieldError from "../../../components/form-field-error/form-field-error";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import PropertyApiService from "../../../data/api/services/property/property-api-service";
import ValidationError from "../../../common/validation-error";
import { Button, Card, Carousel, Col, Container, Modal, Row, Form } from "react-bootstrap";
import { FaChevronDown, FaChevronLeft, FaChevronRight, FaChevronUp, FaTrash } from "react-icons/fa";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import RecommendIcon from '@mui/icons-material/Recommend';
import ShareIcon from '@mui/icons-material/Share';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';

import StorageService from "../../../data/storage/storage-service";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { faAngleLeft, faArrowCircleLeft, faArrowLeft, faCalendar, faChevronLeft, faChevronRight, faClock, faComment, faImage, faLink, faLocationPin, faPercent, faPlusCircle, faTag, faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SabPaisaApiService from "../../../data/api/services/sabpaisa/sabpaisa-api-service";
import ApiConfig from "../../../data/api/api-config";
import AuthApiService from "../../../data/api/services/auth/auth-api-service";
import RegisterApiService from "../../../data/api/services/register/register-api-service";
import TaxApiService from "../../../data/api/services/tax/tax-api-service";
import VerifiedIcon from '@mui/icons-material/Verified';
import Tooltip from '@mui/material/Tooltip';
import { format } from 'date-fns'; // for formatting the selected date
import TimePicker from "react-time-picker";

const AddProfessionPost = (props: any) => {
  const [showTerms, setShowTerms] = useState(false); // initially hidden

    const professionalPageApiService = new ProfessionalPageApiService();
    const propertyApiService = new PropertyApiService();
    const authService: AuthApiService = new AuthApiService();
    const userId = StorageService.getUserId();
    const userType = StorageService.getUserType();
    const [userData, setUserData] = useState<any>([]);
    const apiConfig = new ApiConfig();
    const sabPaisaApiService = new SabPaisaApiService();
    const [sabpaisaUrl, setSabpaisaUrl] = useState("");
    const [encData, setEncData] = useState('');
    const [clientCode, setClientCode] = useState('');
    const [currentPageUrl, setCurrentPageUrl] = useState("");
    const properyCoverImageInput: any = useRef(null);
    const maxLength = 1000;
    const minLength = 0;
    
    const [locationSearchLoading, setLocationSearchLoading] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState<any>([]);
    const [callToActionData, setCallToActionData] = useState([]);
    const [callToActionIdStr, setCallToActionIdStr] = useState("");
    const [offerCallToActionIdStr, setOfferCallToActionIdStr] = useState("");

    const [showCallToActionOption, setShowCallToActionOption] = useState(true);
    const [offerShowCallToActionOption, setOfferShowCallToActionOption] = useState(true);

    const [description, setDescription] = useState('');
    const [termsAndCondition, setTermsAndCondition] = useState('');

    const [callToActionUrl, setCallToActionUrl] = useState('');
    const [offerCallToActionUrl, setOfferCallToActionUrl] = useState('');
    const [actualPrice, setActualPrice] = useState('');
    const [afterDiscount, setAfterDiscount] = useState('');
    const [offerCouponCode, setOfferCoupenCode] = useState('');

    const [postImage, setPostImage] = useState<any>([]);
    const [index, setIndex] = useState(0);
    const [locationValidationErrorMsg, setLocationValidationNameErrorMsg] = useState(null);
    const [callToActionValidationErrorMsg, setCallToActionValidationErrorMsg] = useState(null);
    const [offerCallToActionValidationErrorMsg, setOfferCallToActionValidationErrorMsg] = useState(null);

    const [professionalPagePostFormData, setProfessionalPagePostFormData] = useState<any>(new FormData());
    const [descriptionValidationErrorMsg, setDescriptionValidationErrorMsg] = useState(null);
    const [callToActionUrlValidationErrorMsg, setCallToActionUrlValidationErrorMsg] = useState(null);
    const [offerCallToActionUrlValidationErrorMsg, setOfferCallToActionUrlValidationErrorMsg] = useState(null);

    const [postImageValidationErrorMsg, setPostImageValidationErrorMsg] = useState(null);
    const [userPageData, setUserPageData] = useState<any>([]);
    const [hoveredIcon, setHoveredIcon] = useState(null);
    const [open, setOpen] = useState(false);
    const [endDateOpen, setEndDateOpen] = useState(false);
    const [startTimeOpen, setStartTimeOpen] = useState(false);
    const [endTimeOpen, setEndTimeOpen] = useState(false);

  
    const handleStartDateClick = () => {
      setOpen(!open);
    };
    const handleEndDateClick = () => {
      setEndDateOpen(!endDateOpen);
    };
    const handleStartTimeClick = () => {
      setStartTimeOpen(!startTimeOpen);
    };
    const handleEndTimeClick = () => {
      setEndTimeOpen(!endTimeOpen);
    };
    const [showMore, setShowMore] = useState(false);

  const handleMore = () => {
    setShowMore(prev => !prev);
  };
    const activePageItem = userPageData.find(item => item.activePage === true);
    const userPageId = activePageItem?.id;
    const profileImageUrl = activePageItem?.profileImageUrl;
    const name = activePageItem?.name;
    const professionTypeLabel =activePageItem?.professionTypeLabel;
    const [tagInput, setTagInput] = useState<string>('');
    const [tags, setTags] = useState<string[]>([]);
    const [hoveredTag, setHoveredTag] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [postTagsTemplateData, setPostTagsTemplateData] = useState([]);
    const [youtubeUrl, setYoutubeUrl] = useState('');
    const [whatsAppNumber, setWhatsAppNumber] = useState('');

    const [offerTitle, setOfferTitle] = useState('');

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
   
    const [unPurchasedTagData, setUnPurchasedTagData] = useState<any>([]);
    const [alreadyPurchasedTagData, setAlreadyPurchasedTagData] = useState<any>([]);
    const [selectedTagsToPurchase, setSelectedTagsToPurchase] = useState([]);
    const [selectAllTagsToPurchase, setSelectAllTagsToPurchase] = useState(false);
    const [showPurchaseTagDialog, setShowPurchaseTagDialog] = useState(false);
    const handleShowPurchaseTagDialog = () => setShowPurchaseTagDialog(true);
    const [checkedTagsToPurchase, setCheckedTagsToPurchase] = useState("");
    const [postId, setPostId] = useState('');
    const [showAlertDialog, setShowAlertDialog] = useState(false);
    const [showTagSearchBox, setShowTagSearchBox] = useState(false);
    const [tagSearchLoading, setTagSearchLoading] = useState(false);
    const [searchedTagData, setSearchedTagData] = useState([]);
    const typeaheadRef = useRef<any>(null);
    const [paymentPeriod, setPaymentPeriod] = useState('MONTHLY');
    const [showCodeAppliedText, setShowAppliedText] = useState(false);
    const [showApplyPromoCodePopUp, setShowApplyPromoCodePopUp] = useState(false);
    const [promoCodeValidationError, setPromoCodeValidationError] = useState(false);
    const [verifyCodeProcess, setVerifyCodeProcess] = useState(false);
    const [promoCode, setPromoCode] = useState<any>('');
    const [promoCodeText, setPromoCodeText] = useState("");
    const [coupenCode, setCoupenCode] = useState("");
    const registerService: RegisterApiService = new RegisterApiService();
    const taxApiService = new TaxApiService();
    const [taxPercentage, setTaxPercentage] = useState<any>([]);
    const [hover, setHover] = useState(false);
    const [activeForm, setActiveForm] = useState('');
    const [addphoto, setAddPhoto] = useState('');

    const [showPostForm, setShowPostForm] = useState(false);
    const [isNext, setIsNext] = useState(false);

    const togglePostForm = () => {
        setShowPostForm(!showPostForm);
      };
    const handlePromoCodeChange = (value: any) => {
        setPromoCodeText(value);
        setPromoCodeValidationError(false);
    };
    const handleactiveIconClick = (formType) => {
        setActiveForm(formType);
        togglePostForm(); 
      };
    const validatePromoCode = () => {
        let isFormValid = true;

        if (!promoCodeText) {
            setPromoCodeValidationError(true);
            isFormValid = false;
        }
        return isFormValid;
    };
    const [currentIndex, setCurrentIndex] = useState(0); // Keeps track of the current set of 3 icons

    // const currentIcons = icons.slice(currentIndex, currentIndex + 5);
    const [isToggled, setIsToggled] = useState(true);
    const [isOfferToggled, setIsOfferToggled] = useState(false);

    const handleOfferToggle = () => {
      setIsOfferToggled(prev => !prev);
    };
    const handleToggle = () => {
      setIsToggled(prev => !prev);
    };
    const handleTermsClick = () => {
      setShowTerms(prev => !prev);
    };
    const getPromoCodeByCode = async () => {
        try {
            if (validatePromoCode()) {
                setVerifyCodeProcess(true);
                let res = await registerService.getPromoCodeByCode(promoCodeText);
                setPromoCode(res);
                toast.success("PromoCode Verified!", { containerId: 'TR' });
                console.log('PromoCode', res);
            }
        } catch (err: any) {
            setVerifyCodeProcess(false);
            toast.error(err.response.data.message, { containerId: 'TR' });
        }
    };

    const applyPromoCode = () => {
        setShowApplyPromoCodePopUp(false);
        toast.success("PromoCode Applied Successfully!", { containerId: 'TR' });
        setCoupenCode(promoCodeText);
        setShowAppliedText(true);
    };

    const searchTagToPurchase = async (tagName: any) => {
        setTagSearchLoading(true);
        let data = await propertyApiService.searchTag(tagName);
        data = data.filter((tag: any) =>
            !unPurchasedTagData.some((selectedTag: any) => selectedTag.id === tag.id) &&
            !tags.includes(tag.tagName));
        console.log(tagName);
        setTagSearchLoading(false);
        setSearchedTagData(data);
    };

    const handleSearchedTagSelected = (item: any) => {
        if (item.length > 0) {
            const selectedTag = item[0];
            console.log(selectedTag);
            getTagPurchaseByTagId(selectedTag, 'SEARCH_TAG');
            setUnPurchasedTagData((prevArray) => {
                // const isTagAlreadyAdded = prevArray.some(tag => tag.id === selectedTag.id);
                // if (isTagAlreadyAdded) {
                //     return prevArray;
                // }
                const updatedArray = [...prevArray, selectedTag];
                setSelectAllTagsToPurchase(updatedArray.length === unPurchasedTagData.length);
                return updatedArray;
            });
            setSearchedTagData([]);
            typeaheadRef.current.clear();
        }
    };
      const handleDragStart = (e, index) => {
    e.dataTransfer.setData('draggedItem', index);
  };

  // Handle drop (reorder images)
  const handleDrop = (e, targetIndex) => {
    const draggedIndex = e.dataTransfer.getData('draggedItem');
    if (draggedIndex === targetIndex) return; // Ignore if the same item is dragged

    const updatedImages = [...postImage];
    const [draggedItem] = updatedImages.splice(draggedIndex, 1); // Remove the dragged item
    updatedImages.splice(targetIndex, 0, draggedItem); // Insert it at the new position

    setPostImage(updatedImages);
  };

  // Handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
  };

    const handleAlertYes = () => {
        window.location.reload();
    };

    const handleAlertNo = () => {
        setShowAlertDialog(false);
    };

    const handleClosePurchaseTagDialog = () => {
        setShowAlertDialog(true);
    }
    const handleClick = () => {
        setActiveForm('Add Image/video');

      };
    const handleCheckboxChange = (index, isChecked) => {
        setSelectedTagsToPurchase((prev) => {
            const updatedTags = isChecked
                ? [...prev, index]
                : prev.filter((i) => i !== index);
            setSelectAllTagsToPurchase(updatedTags.length === unPurchasedTagData.length);
            const tagNamesString = updatedTags
                .map(tagIndex => unPurchasedTagData[tagIndex]?.tagName)
                .join(", ");
            setCheckedTagsToPurchase(tagNamesString);
            return updatedTags;
        });
    };

    const handleSelectAllTagsToPurchaseChange = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            const allIndexes = unPurchasedTagData.map((_, index) => index);
            setSelectedTagsToPurchase(allIndexes);
            const tagNamesString = unPurchasedTagData
                .map(tag => tag?.tagName)
                .join(", ");
            console.log(tagNamesString, 'tagnames (select all)');
            setCheckedTagsToPurchase(tagNamesString);
        } else {
            setSelectedTagsToPurchase([]);
            setCheckedTagsToPurchase("");
        }
        setSelectAllTagsToPurchase(isChecked);
    };

    const totalCost = selectedTagsToPurchase.reduce((acc, curr) => {
        const tagItem = unPurchasedTagData[curr];
        const isPurchased = alreadyPurchasedTagData.some(data => data.id === tagItem.id);
        const tagCost = isPurchased
            ? 0
            : paymentPeriod === 'MONTHLY'
                ? parseFloat(tagItem.monthlyTagCost)
                : parseFloat(tagItem.yearlyTagCost) > 0
                    ? parseFloat(tagItem.yearlyTagCost)
                    : parseFloat(tagItem.monthlyTagCost) * 10;
        return acc + tagCost;
    }, 0);

    const taxRate = taxPercentage.taxPercentage / 100;

    const taxAmount = (totalCost * taxRate).toFixed(2);

    const grandTotal = (parseFloat(totalCost) + parseFloat(taxAmount)).toFixed(2);

    const handleCallToActionChange = (btId: any) => {
        setCallToActionIdStr(btId);
        setShowCallToActionOption(false);
    };
    const handleOfferCallToActionChange = (ocId: any) => {
      setOfferCallToActionIdStr(ocId);
      setOfferShowCallToActionOption(false);

  };
    const handleDescriptionOnChange = (ds: any) => {
        setDescription(ds);
    };
    const handleTermsAndConditionOnChange = (tc: any) => {
      setTermsAndCondition(tc);
  };
    const handleYoutubeURLOnChange = (value: any) => {
        setYoutubeUrl(value)
    };
    const handleWhatsAppNumberOnChange = (value: any) => {
      setWhatsAppNumber(value)
  };
    const handleOfferTitleOnChange = (value: any) => {
      setOfferTitle(value)
  };
    const handleStartDateOnChange = (value: any) => {
      setStartDate(value)
  };
  const handleEndDateOnChange = (value: any) => {
    setEndDate(value)
};
const handleStartTimeOnChange = (timeValue: string) => {
  let date = new Date(); 

  const adjustedDate = setSeconds(setMinutes(setHours(date, 0), 0), 0);

  
  setStartTime(adjustedDate); 
};
const handleEndTimeOnChange = (value: any) => {
  let date = new Date(); 

  const adjustedDate = setSeconds(setMinutes(setHours(date, 0), 0), 0);

  
  setEndTime(adjustedDate); 
};
    const handlecallToActionUrlOnChange = (cu: any) => {
        setCallToActionUrl(cu);
    };
    const handleActualPriceOnChange = (ap: any) => {
      setActualPrice(ap);
  };
  const handleAfterDiscountOnChange = (ap: any) => {
    setAfterDiscount(ap);
};
const handleOfferCouponCodeOnChange = (cc: any) => {
  setOfferCoupenCode(cc);
};
    const handleOfferCallToActionUrlOnChange = (ou: any) => {
      setOfferCallToActionUrl(ou);
  };

    const onUploadPostListener = (event: any) => {
        let images: any = [];
        for (let i = 0; i < event.target.files.length; i++) {
            let image: any = {};
            image.file = event.target.files[i];
            image.url = URL.createObjectURL(image.file);
            images.push(image);
        }
        setPostImage(prevImages => [...prevImages, ...images]);
        setPostImageValidationErrorMsg('');
    }
    const moveImageUp = (index) => {
        if (index === 0) return; // Already at the top
        const updatedImages = [...postImage];
        const [movedImage] = updatedImages.splice(index, 1);
        updatedImages.splice(index - 1, 0, movedImage);
        setPostImage(updatedImages);
      };
    
      // Move image or video down
      const moveImageDown = (index) => {
        if (index === postImage.length - 1) return; // Already at the bottom
        const updatedImages = [...postImage];
        const [movedImage] = updatedImages.splice(index, 1);
        updatedImages.splice(index + 1, 0, movedImage);
        setPostImage(updatedImages);
      };
    const onProfessionalPageUploadPostListener = (event: any) => {
        const files = event.target.files;
        if (files.length > 0) {
            let mediaFiles: any = [];
            for (let i = 0; i < files.length; i++) {
                let media: any = {};
                media.file = files[i];
                if (media.file.type.startsWith('image/')) {
                    media.imagePath = URL.createObjectURL(media.file);
                    media.type = 'image';
                } else if (media.file.type.startsWith('video/')) {
                    media.videoPath = URL.createObjectURL(media.file);
                    media.type = 'video';
                }
                mediaFiles.push(media);
            }
            setPostImage(prevImages => [...prevImages, ...mediaFiles]);
            setPostImageValidationErrorMsg('');
        } else {
            setPostImage([]);
        }
    };

    const clearCoverImage = (index: number) => {
        const updatedImages = [...postImage];
        updatedImages.splice(index, 1);
        setPostImage(updatedImages);
    }

   
    const showValidationErrorInlineUI = (error: ValidationError) => {
        let errors: any[] = error.errors;
        for (let i = 0; i < errors.length; i++) {
            let error: any = errors[i];
            let errorCode: any = error.validationCode;
            let errorMsg: any = error.message;

            if (errorCode === 'mediaUrl') {
                setPostImageValidationErrorMsg(errorMsg);
            }
            if (errorCode === 'taggedLocationId') {
                setLocationValidationNameErrorMsg(errorMsg);
            }
        }
    }

    const validateAndUploadPostFormData = () => {
        try {
            if (professionalPagePostFormData.has("mediaUrl")) {
                professionalPagePostFormData.delete('mediaUrl');
            } for (let i = 0; i < postImage.length; i++) {
                professionalPagePostFormData.append('mediaUrl', postImage[i].file);
            }

            if (professionalPagePostFormData.has('callToAction')) {
                professionalPagePostFormData.delete('callToAction');
            }
            professionalPagePostFormData.append('callToAction', callToActionIdStr);

            if (professionalPagePostFormData.has("professionalPostId")) {
                professionalPagePostFormData.delete('professionalPostId');
            }
            professionalPagePostFormData.append('professionalPostId', userPageId);

            if (professionalPagePostFormData.has('taggedLocationId')) {
                professionalPagePostFormData.delete('taggedLocationId');
            }
            if (selectedLocation.length > 0) {
                professionalPagePostFormData.append('taggedLocationId', selectedLocation[0].id);
            }

            if (professionalPagePostFormData.has('caption')) {
                professionalPagePostFormData.delete('caption');
            }
            professionalPagePostFormData.append('caption', description);
            if (professionalPagePostFormData.has('callToActionUrl')) {
                professionalPagePostFormData.delete('callToActionUrl');
            }
            professionalPagePostFormData.append('callToActionUrl', callToActionUrl);

            if (professionalPagePostFormData.has("tags")) {
                professionalPagePostFormData.delete('tags');
            }
            professionalPagePostFormData.append('tags', concatenatedTags);
            if (professionalPagePostFormData.has('youtubeUrl')) {
                professionalPagePostFormData.delete('youtubeUrl');
            }
            professionalPagePostFormData.append('youtubeUrl', youtubeUrl);
           
         
            if (professionalPagePostFormData.has('offerTitle')) {
              professionalPagePostFormData.delete('offerTitle');
          }
          professionalPagePostFormData.append('offerTitle', offerTitle);
          if (professionalPagePostFormData.has('startDate')) {
            professionalPagePostFormData.delete('startDate');
        }
        professionalPagePostFormData.append('startDate', startDate);
        if (professionalPagePostFormData.has('endDate')) {
          professionalPagePostFormData.delete('endDate');
      }
      professionalPagePostFormData.append('endDate', endDate);
      if (professionalPagePostFormData.has('startTime')) {
        professionalPagePostFormData.delete('startTime');
    }
    professionalPagePostFormData.append('startTime', startTime);
    if (professionalPagePostFormData.has('endTime')) {
      professionalPagePostFormData.delete('endTime');
  }
  professionalPagePostFormData.append('endTime', endTime);
  
  if (professionalPagePostFormData.has('offerCallToAction')) {
    professionalPagePostFormData.delete('offerCallToAction');
}
professionalPagePostFormData.append('offerCallToAction', offerCallToActionIdStr);
if (professionalPagePostFormData.has('offerCallToActionUrl')) {
  professionalPagePostFormData.delete('offerCallToActionUrl');
}
professionalPagePostFormData.append('offerCallToActionUrl', offerCallToActionUrl);
if (professionalPagePostFormData.has('actualPrice')) {
  professionalPagePostFormData.delete('actualPrice');
}
professionalPagePostFormData.append('actualPrice', actualPrice);
if (professionalPagePostFormData.has('afterDiscount')) {
  professionalPagePostFormData.delete('afterDiscount');
}
professionalPagePostFormData.append('afterDiscount', afterDiscount);
if (professionalPagePostFormData.has('offerCouponCode')) {
  professionalPagePostFormData.delete('offerCouponCode');
}
professionalPagePostFormData.append('offerCouponCode', offerCouponCode);
if (professionalPagePostFormData.has('termsAndCondition')) {
  professionalPagePostFormData.delete('termsAndCondition');
}
professionalPagePostFormData.append('termsAndCondition', termsAndCondition);
if (professionalPagePostFormData.has('whatsAppNumber')) {
  professionalPagePostFormData.delete('whatsAppNumber');
}
professionalPagePostFormData.append('whatsAppNumber', whatsAppNumber);
if (professionalPagePostFormData.has('postType')) {
  professionalPagePostFormData.delete('postType');
}

professionalPagePostFormData.append(
  'postType',
  isOfferToggled ? 'OFFER_POST' : 'NORMAL_POST'
);


        } 
        catch (error: any) {
            throw error;
        }
    }

    const uploadProfessionalPagePost = async () => {
        try {
            validateAndUploadPostFormData();
            setLoading(true);
            let data = await professionalPageApiService.uploadProfessionalPagePost(professionalPagePostFormData);
            setPostId(data.id);
            if (data) {
                if (userType === "ROLE_PRO_USER" || !concatenatedTags) {
                    window.location.reload();
                    toast.success('Uploaded Post Successfully', { containerId: 'TR' });

                } else {
                    getTagByTagName(concatenatedTags);
                }
            }
        } catch (error) {
            showValidationErrorInlineUI(error);
        }
    };
    const handleDateSelect = (date) => {
      setStartDate(date);
      setOpen(false);
      
    };
    const handleEndTimeSelect = (date) => {
      setEndTime(date);
      setEndTimeOpen(false);
    };
    const handleStartTimeSelect = (date) => {
      setStartTime(date);
      setStartTimeOpen(false);
    };
    const handleEndDateSelect = (date) => {
      setEndDate(date);
      setEndDateOpen(false);
    };
    const searchLocation = async (q: any) => {
        setLocationSearchLoading(true);
        let data = await propertyApiService.searchLocation(q);
        console.log(q);
        setLocationSearchLoading(false);
        formatLocationData(data);
    };

    const formatLocationData = (data: any) => {
        formatLocationDataResponse(data);
        setLocationData(data);
    };

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const formatLocationDataResponse = (data: any) => {
        for (let i = 0; i < data.length; i++) {
            data[i].nameLabel = data[i].name + ' | ' + data[i].pinCode;
        }
    };

    const onLocationSelected = (e: any) => {
        if (e.length > 0) {
            console.log(e[0]);
            setSelectedLocation(e);
        }
        setLocationValidationNameErrorMsg('');
    };
    const icons = [
      { icon: faImage, color: 'green', tooltip: 'Add Image/video' },
      { icon: faLocationPin, color: 'orange', tooltip: 'Add Location' },
      { icon: faTag, color: 'blue', tooltip: 'Add Tag' },
      { icon: faLink, color: 'red', tooltip: 'Add YouTube Video' },
      
      { icon: faComment, color: 'green', tooltip: 'Add WhatsApp' },


     
    
      ...(userType === 'ROLE_PRO_USER' && !isOfferToggled
        ? [{ icon: faComment, color: 'violet', tooltip: 'Add calltoAction' }]
        : []),
    ];
    
      
    const clearSelectedLocation = () => {
        setSelectedLocation([]);
    };

    const getTemplateData = async () => {
        let data = await professionalPageApiService.getProfessionalPageTemplateData();
        console.log(data);
        setCallToActionData(data.callToActionData);
    };
    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 4) % icons.length); 
        setIsNext((prevState) => !prevState);
      };
     
    const getProfessionalPageDetails = async () => {
        try {
            console.log(userId);
            let res = await professionalPageApiService.getProfessionalPageData(userId);
            setUserPageData(res);
        } catch (error) {
            console.log(error);
        }
    };

    const getProfessionalPagePostTagTemplateData = async () => {
        let data = await professionalPageApiService.getProfessionalPagePostTagTemplateData();
        console.log(data);
        setPostTagsTemplateData(data);
    };

    const getTagByTagName = async (tagName) => {
        try {
            let res = await professionalPageApiService.getTagByTagName(tagName);
            console.log(res);
            let shouldReload = true;
            for (let tag of res) {
                if (tag.monthlyTagCost > 0) {
                    const conditionMet = await getTagPurchaseByTagId(tag, 'UPLOAD_POST');
                    if (conditionMet) {
                        shouldReload = false;
                    }
                }
            }
            if (shouldReload) {
                toast.success('Uploaded Post Successfully', { containerId: 'TR' });
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTagPurchaseByTagId = async (tagData, accessFrom) => {
        try {
            let res = await professionalPageApiService.getTagPurchaseByTagId(tagData.id);
            console.log(res);
            if (accessFrom == 'UPLOAD_POST') {
                const matchingEntries = res.filter(entry => entry.personId === userId);
                if (matchingEntries.length <= 0) {
                    setLoading(false);
                    handleShowPurchaseTagDialog();
                    setUnPurchasedTagData(prevArray => [...prevArray, tagData]);
                    return true;
                } else {
                    setAlreadyPurchasedTagData(prevArray => [...prevArray, tagData]);
                }
                return false;
            } else if (accessFrom == 'SEARCH_TAG') {
                const matchingEntries = res.filter(entry => entry.personId === userId);
                if (matchingEntries.length > 0) {
                    setAlreadyPurchasedTagData(prevArray => [...prevArray, tagData]);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTaxResponse = async () => {
        try {
            let data = await taxApiService.getTax();
            setTaxPercentage(data);
            console.log(data, 'Tax');
        } catch (error) {
        }
    };

    useEffect(() => {
        const currentUrl = window.location.href;
        setCurrentPageUrl(currentUrl);
        console.log("Current URL:", currentUrl);
        setSabpaisaUrl(apiConfig.getSabpaisaURL);
        getUser();
        getProfessionalPageDetails();
        getTemplateData();
        getProfessionalPagePostTagTemplateData();
        getTaxResponse();
    }, [unPurchasedTagData]);

    const handleSubmit = () => {
        const form = document.getElementById('sabPaisaForm') as HTMLFormElement;
        if (form) {
            form.submit();
        }
    };

    useEffect(() => {
        if (shouldSubmit) {
            handleSubmit();
        }
    }, [encData, clientCode]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTagInput(event.target.value);
    };

    const handleInputKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === ',' || event.key === 'Enter') {
            event.preventDefault();
            addTag();
        }
    };
    const renderMenuItemChildren = (option, props, index) => {

        return (
            <div key={index}>
                         <span style={{ color: 'black', marginRight: '5px' }}>{option.name}</span>
                <Tooltip title={option.isVerified ? 'Verified Location' : 'Location Not Verified'}>
                    <VerifiedIcon 
                        sx={{
                            color: option.isVerified ? '#0d6efd' : 'grey',  
                            fontSize: '15px', 
                        }} 
                    />
                </Tooltip>
{' | '}
                <span style={{ color: 'blue' }}>{option.pinCode}</span>
                {' | '}
                <span style={{ color: 'red' }}>{option.postOfficeName}</span>
                {' | '}
                <span style={{ color: 'green' }}>{option.talukaName}</span>
                {' | '}
                <span style={{ color: 'orange' }}>{option.districtName}</span>
                {' | '}
                <span style={{ color: '#fa0acc' }}>{option.abbreviation}</span>

            </div>
        );
    };
    const addTag = () => {
        if (tagInput.trim() !== '') {
            if (!tags.includes(tagInput.trim())) {
                setTags([...tags, tagInput.trim()]);
            }
            setTagInput('');
        }
    };

    const concatenatedTags = tags.join(',');

    const removeTag = (tagToRemove: string) => {
        setTags(tags.filter(tag => tag !== tagToRemove));
    };

    const [shouldSubmit, setShouldSubmit] = useState(false);

    const getUser = async () => {
        try {
            let res = await authService.getUser(userId);
            console.log('dataaaaaa=>', res);
            setUserData(res);
        } catch (error) {
            console.log(error);
        }
    };

    const handlePay = () => {
        getSabPaisaResponse();
    };

    const getSabPaisaResponse = async () => {
        try {
            console.log(currentPageUrl, 'Encoded Page URL');
            let url = `?payerName=${userData.firstName}&payerEmail=${userData.email}
            &payerMobile=${userData.mobile}&amount=${grandTotal}&accessPageFrom=${'MY_PROFILE_PAGE_ADD_POST'}
            &logInType=${userData.logInType}&tagName=${checkedTagsToPurchase}&postId=${postId}
            &pageId=${userPageId}&pageUrl=${currentPageUrl}&paymentPeriod=${paymentPeriod}`;
            console.log(currentPageUrl, 'gjhgjhsgcjhgcjhsjcjjsvcjvsvdch')
            let data = await sabPaisaApiService.getSabPaisaResponse(url);
            console.log(data);
            setEncData(data.encData);
            setClientCode(data.clientCode);
            setShouldSubmit(true);
        } catch (error) {
            if (error.response && error.response.data) {
                console.error('Error response data:', error.response.data);
            } else {
                console.error('Error fetching SabPaisa response:', error.message);
            }
        }
    };

    return <>
        <div style={{ position: 'relative' }}>
            {/* {loading && (
                <div className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 10
                    }}>
                    <div className="loading">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            )} */}
            {loading && (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      zIndex: 10,
      flexDirection: 'column',
    }}
  >
    <svg width="120" height="120" viewBox="0 0 36 36" className="circular-chart blue">
      <path
        className="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#eee"
        strokeWidth="2"
      />
      <path
        className="circle"
        strokeDasharray="10, 100"  
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#00acc1"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <text x="18" y="20.35" className="percentage" textAnchor="middle" fontSize="4" fill="#00acc1">
        10%
      </text>
    </svg>
  </div>
)}

              <div>
       <div 
  className={`hero-search-wrap-post mt-3 mx-auto pt-3 text-end ${showPostForm ? 'hide' : 'slide-left-post'}`}
>        

      <div className="justify-content-center p-2">
   
      <Col md={11} className="position-relative text-center">
  <h6 >Create Post</h6>
  
  <Tooltip title="close" arrow>
    <div
      onClick={props.handleClose}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        borderRadius: '50%',
        padding: '2px',
        cursor: 'pointer',
        transition: 'background 0.3s',
        backgroundColor: hover ? '#e0e0e0' : 'transparent',
      }}
    >
      <FontAwesomeIcon
        icon={faTimes}
        style={{ color: 'black', fontSize: '18px' }}
      />
    </div>
  </Tooltip>
</Col>


     

      
      <hr></hr>

      <div className="post-content">
            <Row>
            <Col md={8} xs={8} className="d-flex align-items-center">
            <img
  src={profileImageUrl ? profileImageUrl :Avatar}
  height="50"
  width="50"
  style={{ borderRadius: '50%' }}
/>
              <div className="mx-2">
                <h6 className="m-0 d-flex">{name}</h6>
                <p className="m-0 d-flex">{professionTypeLabel}</p>
          
              </div>
            </Col>
            <Col md={4} xs={4} className="d-flex align-items-start">
            <div className="mx-0">
            <img
      src={isOfferToggled ? Offer : offerInactive}
      height="16"
  width="16"
  style={{ borderRadius: '50%' }}
/>
</div>
              <div className="mx-1">
              <label style={{ fontSize: '10px',    color: isOfferToggled ? 'green' : 'grey'
,whiteSpace:'nowrap' }}>
  Offer Post
</label>
</div>
<div className="mx-1">
<button
            type="button"
            className={`btn btn-sm btn-toggle ${isOfferToggled ? 'active' : ''}`}
            aria-pressed={isOfferToggled}
            onClick={handleOfferToggle}
          >
            <div className="handle"></div>
          </button>
          
              </div>
              
         
            </Col>
            </Row>
         

            <div className="custom-textarea-button">
  <textarea
    placeholder={`What's on your mind, ${name}?`}
    value={description}
    minLength={minLength}
    maxLength={maxLength}
    onChange={(e) => handleDescriptionOnChange(e.target.value)}
    spellCheck="false"
  />
 
 {postImage.length ==0 && (
   <Row className="add-photo-video mx-auto align-items-center mt-3"       
 onClick={() => {
  
      handleactiveIconClick('Add Image/video');

  }}        style={{ cursor: 'pointer' }} 

>
   <Col xs={12} className="align-items-center" >
   <FontAwesomeIcon
          icon={faImage}
          style={{ color: '#7b6f6f', fontSize: '14px',cursor:'pointer' }}
          onClick={() => {
  
            handleactiveIconClick('Add Image/video');
      
        }}       

        />
            <label className="image mx-1"  onClick={() => {
  
  handleactiveIconClick('Add Image/video');

}}        style={{ cursor: 'pointer' }} >Add photos/videos</label>

  </Col>
  

 
</Row>
    )}
<div className="mt-3 mx-4 image-grid">
  {postImage.slice(0, 3).map((postImg, index) => {
    const remaining = postImage.length - 3;
    const showOverlay = index === 2 && remaining > 0;

    return (
      <div
        key={'post_image_' + index}
        className="Add-photo-preview"
        draggable
        onDragStart={(e) => handleDragStart(e, index)}
        onDrop={(e) => handleDrop(e, index)}
        onDragOver={handleDragOver}
      >
        <div
          className="remove-icon"
          style={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            cursor: 'pointer',
            color: 'red',
            fontSize: '20px',
            zIndex: 2,
          }}
          onClick={() => clearCoverImage(index)}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </div>

        <div className="col-sm-12 d-flex align-items-center justify-content-center" style={{ width: '100%' }}>
          {postImg.type === 'image' ? (
            <img
              src={postImg.imagePath}
              alt="Uploaded"
              style={{
                width: '100%',
                height: '150px',
                objectFit: 'cover',
              }}
            />
          ) : (
            <>
              <video
                style={{
                  width: '100%',
                  height: '150px',
                  objectFit: 'cover',
                }}
                controls
              >
                <source src={postImg.videoPath} type={postImg.file.type} />
              </video>
              <div className="d-flex align-items-center justify-content-center video-play-icon">
                <PlayCircleOutlineIcon style={{ fontSize: '40px', color: '#fff' }} />
              </div>
            </>
          )}
        </div>

        {showOverlay && (
          <div
          className="image-index"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: '#fff',
            padding: '2px 6px',
            borderRadius: '50px',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
            +{remaining}
          </div>
        )}
      </div>
    );
  })}
    {postImage.length > 0 && (
    <div className="Add-photo-preview text-center  mx-2">
      <label
        htmlFor="fileInput"
        className="add-icon-container"
        style={{
          fontWeight: '500',
          fontSize: '16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <FontAwesomeIcon
          icon={faPlusCircle}
          size="lg"
          style={{ color: '#d47e8d', cursor: 'pointer' }}
        />
        <span style={{ fontSize: '15px', color: '#d47e8d' }}>Add pics</span>
      </label>
    </div>
  )}
</div>
{isOfferToggled && ( 
<div>
           <Row className="mt-auto">
                                        <Col className="mb-2 text-center">
                                            <div className={`post-input-field mt-2`} >
       
       <input
           className="pe-5"
           type= "text" 
           placeholder=" "
           value={offerTitle}
           onChange={e => { handleOfferTitleOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">Offer title (required)</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                        </Col>
                                    </Row>
             
               
              
           
 

          </div>
)}
{isOfferToggled && ( 
          <label className="example-label mx-4">(Example: 20% off in store or online)</label>
)}
{isOfferToggled && (   
          <Row>
      <Col xs={12} className="mb-2 text-end" style={{ position: 'relative' }}>
        <div>
        <label className="offer-time-label me-2">
  {isToggled ? 'Life Time' : 'Limited Time'}
</label>

          <button
            type="button"
            className={`btn btn-sm btn-toggle ${isToggled ? 'active' : ''}`}
            aria-pressed={isToggled}
            onClick={handleToggle}
            style={{
              backgroundColor: isToggled ? '' : '#f3d653',
            }}
          >
            <div className="handle"></div>
          </button>
        </div>
      </Col>
    </Row>  
)}
{isOfferToggled && !isToggled &&( 
<div>
          <Row className="mt-3">
      <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
        <div className="post-input-field mt-2">
          <input
            className="pe-5"
            type="text"
            placeholder=" "
            value={startDate ? format(startDate, 'd MMMM yyyy') : ''} 
            onChange={e => handleStartDateOnChange(e.target.value)}
            readOnly // prevent manual typing, optional
          />
          <span className="fw-bold post-input-field-placeholder mx-2">Start Date</span>
          <span
            className="password-toggle-icon px-2"
            style={{ color: "#aaa", cursor: "pointer" }}
            onClick={handleStartDateClick}
          >
            <FontAwesomeIcon icon={faCalendar} style={{ fontSize: '24px' }} />
          </span>
        </div>
        <div>
        <Row xs={12} className="mb-2 text-end" >

        {open && (
  <div>
    <DatePicker
      selected={startDate}
      onChange={handleDateSelect}
      inline
      // Optional: Add these to double-check navigation behavior
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        
      

          <div >
          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <span>{date.toLocaleString('default', { month: 'long' })} {date.getFullYear()}</span>
          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
     
        
      )}
    />
  </div>
)}

              </Row>
              </div>

      </Col>
     
       
      <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
  <div className="post-input-field mt-2">
    <input
      className="pe-5"
      type="text"
      placeholder=" "
      value={startTime ? format(startTime, 'hh:mm a') : ''}
      onChange={e => handleStartTimeOnChange(e.target.value)}
      readOnly // optional, disables manual typing
    />
    <span className="fw-bold post-input-field-placeholder mx-2">Start Time</span>

    <span
      className="password-toggle-icon px-2"
      style={{ color: "#aaa", cursor: "pointer" }}
      onClick={handleStartTimeClick}
      >
      <FontAwesomeIcon icon={faClock} style={{ fontSize: '24px' }} />
    </span>

   
  </div>
  <div>
      <Col xs={12} className="mb-2 text-end" style={{ position: 'relative' }}>

    {startTimeOpen && (
          <DatePicker
          selected={startTime}
          onChange={handleStartTimeSelect}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={1}
          timeCaption="Time"
          dateFormat="h:mm aa"
          inline
        />
        )}
           </Col>
</div>
</Col>

    
    </Row>
  </div>
)}
{isOfferToggled && !isToggled && ( 
  <div>
        <Row className="mt-3">
      
        <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
        <div className="post-input-field mt-2">
          <input
            className="pe-5"
            type="text"
            placeholder=" "
            value={endDate ? format(endDate, 'd MMMM yyyy') : ''} 
            onChange={e => handleEndDateOnChange(e.target.value)}
            readOnly // prevent manual typing, optional
          />
          <span className="fw-bold post-input-field-placeholder mx-2">End Date</span>
          <span
            className="password-toggle-icon px-2"
            style={{ color: "#aaa", cursor: "pointer" }}
            onClick={handleEndDateClick}
          >
            <FontAwesomeIcon icon={faCalendar} style={{ fontSize: '24px' }} />
          </span>
        </div>
        <div>
        <Row xs={12} className="mb-2 text-end" >

{endDateOpen && (
<div>
<DatePicker
selected={endDate}
onChange={handleEndDateSelect}
inline
// Optional: Add these to double-check navigation behavior
renderCustomHeader={({
date,
decreaseMonth,
increaseMonth,
prevMonthButtonDisabled,
nextMonthButtonDisabled,
}) => (



  <div >
  <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
    {"<"}
  </button>
  <span>{date.toLocaleString('default', { month: 'long' })} {date.getFullYear()}</span>
  <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
    {">"}
  </button>
</div>


)}
/>
</div>
)}

      </Row>
              </div>
      
      </Col>
      
<Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
  <div className="post-input-field mt-2">
    <input
      className="pe-5"
      type="text"
      placeholder=" "
      value={endTime ? format(endTime, 'hh:mm a') : ''}
      onChange={e => handleEndTimeOnChange(e.target.value)}
      readOnly // optional, disables manual typing
    />
    <span className="fw-bold post-input-field-placeholder mx-2">End Time</span>

    <span
      className="password-toggle-icon px-2"
      style={{ color: "#aaa", cursor: "pointer" }}
      onClick={handleEndTimeClick}
      >
      <FontAwesomeIcon icon={faClock} style={{ fontSize: '24px' }} />
    </span>

   
  </div>
  <div>
      <Col xs={12} className="mb-2 text-end" style={{ position: 'relative' }}>

    {endTimeOpen && (
          <DatePicker
          selected={endTime}
          onChange={handleEndTimeSelect}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={1}
          timeCaption="Time"
          dateFormat="h:mm aa"
          inline
        />
        )}
           </Col>
</div>
</Col>
  
                                    </Row>
    </div>   
)}  

{isOfferToggled && ( 
    <div>
          <label className="example-label mx-4">Add a button(optional)</label>
          <Row className="mt-1">
          <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
          <div className={`post-input-field mt-4 `} >
        
       
        <select
                   className="pe-5"
    
          value={offerCallToActionIdStr}
          onChange={(e) => handleOfferCallToActionChange(e.target.value)}
        >
          {offerShowCallToActionOption && <option>Select</option>}
          {callToActionData && callToActionData.map((ctaData: any, index: any) => (
            <option className="text-edit" key={ctaData.id} value={ctaData.id}>
              {ctaData.label}
            </option>
          ))}
        </select>
           <span className="fw-bold post-input-field-placeholder mx-2">CallToAction</span>
           <span className="password-toggle-icon px-2"
               style={{ color: "#aaa" }}>
           </span>
       </div>
        
        <FormFieldError errorMessage={offerCallToActionValidationErrorMsg}></FormFieldError>
                                           
                                        </Col>
                                        <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
                                        <div className={`post-input-field mt-4 `} >
       
       <input
                  className="pe-5"

      type= "text" 
           placeholder=" "
           value={offerCallToActionUrl}
           onChange={e => { handleOfferCallToActionUrlOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">URL</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                        </Col>
                                    </Row>
</div>
)}
{isOfferToggled && (
  <Col md={11} className="d-flex justify-content-end">
  <label style={{ cursor: 'pointer' }} onClick={handleMore}>
    {showMore ? (
      <>
        Less <FaChevronUp />
      </>
    ) : (
      <>
        More <FaChevronDown />
      </>
    )}
  </label>
</Col>

)}
{isOfferToggled && showMore && ( 
<div>
          <Row className="mt-1">
          <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
                                        <div className={`post-input-field mt-4 `} >
       
       <input
                  className="pe-5"

      type= "number" 
           placeholder=" "
           value={actualPrice}
           onChange={e => { handleActualPriceOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">Actual Price</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                           
                                        </Col>
                                        <Col xs={6} className="mb-2 text-center" style={{ position: 'relative' }}>
                                        <div className={`post-input-field mt-4 `} >
       
       <input
                  className="pe-5"

      type= "number" 
           placeholder=" "
           value={afterDiscount}
           onChange={e => { handleAfterDiscountOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">After Discount</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                        </Col>
                                    </Row>
</div>
)}
{isOfferToggled && showMore && ( 
<div>
          <Row className="mt-1">
          <Col xs={12} className="mb-2 text-center" style={{ position: 'relative' }}>
                                        <div className={`post-input-field mt-4 `} >
       
       <input
                  className="pe-5"

      type= "text" 
           placeholder=" "
           value={offerCouponCode}
           onChange={e => { handleOfferCouponCodeOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">Coupon Code (optional)</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                           
                                        </Col>
                                      
                                    </Row>
</div>
)}
{isOfferToggled && showMore && ( 
<div>
<Col md={11} className="d-flex justify-content-center">
  <label
    onClick={handleTermsClick}
    style={{ cursor: 'pointer' }}
  >
    Terms and Condition {showTerms ? <FaChevronUp /> : <FaChevronDown />}
  </label>
</Col>
{showTerms && (
  <textarea
  placeholder={` Start To Write Your Terms And Condition`}
  value={termsAndCondition}
  minLength={minLength}
  maxLength={maxLength}
  onChange={(e) => handleTermsAndConditionOnChange(e.target.value)}
  spellCheck="false"
/>
  )}
  </div>
)}
 

   
  <Row className="align-items-center custom-options mt-4">
  <Col xs={3} className="text-start">
    <label className="no-wrap">Post options</label>
  </Col>

  <Col xs={9} className="d-flex text-end">
  {icons.map((icon, index) => (
    <Tooltip key={index} title={icon.tooltip} arrow>
      <div
        onClick={() => {
          if (icon.icon === faChevronRight || icon.icon === faChevronLeft) {
            handleNext();
          } else {
            handleactiveIconClick(icon.tooltip);
          }
        }}
        onMouseEnter={() => setHoveredIcon(index)}
        onMouseLeave={() => setHoveredIcon(null)}
        style={{
          color: icon.color,
          cursor: 'pointer',
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '8px',
          borderRadius: '50%',
          backgroundColor:
            hoveredIcon === index ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
          transition: 'background 0.3s ease',
        }}
      >
        <FontAwesomeIcon
          icon={icon.icon}
          style={{ color: icon.color, fontSize: '18px' }}
        />
      </div>
    </Tooltip>
  ))}
</Col>
</Row>

{!isOfferToggled && ( 
<button 
  onClick={uploadProfessionalPagePost} 
  className={`custom-button ${
    description.trim().length > 0 || postImage.length > 0 ? 'custom-button-enabled' : ''
  }`}
  >
  Post
</button>
)}

{isOfferToggled && ( 
<button 
  onClick={uploadProfessionalPagePost} 
  className={`custom-button ${
    offerTitle.trim().length > 0 && (description.trim().length > 0 || postImage.length > 0)
    ? 'custom-button-enabled'
    : ''
    }`}
  >
  Post
</button>
)}
{isOfferToggled && ( 
  <div
    className="d-flex flex-column align-items-center justify-content-center my-3"
    style={{
      cursor: 'pointer',
      color: '#096a8aeb',
    }}
  >
    {(  offerTitle.trim().length > 0 && description.trim().length > 0 || postImage.length > 0) && (
    <a
      onClick={() => {
        handleactiveIconClick('preview');
      }}
    >
      See Preview
    </a>
    )}
  </div>
)}

{!isOfferToggled && (   <div
    className="d-flex flex-column align-items-center justify-content-center my-3"
    style={{
      cursor: 'pointer',
      color: '#096a8aeb',
    }}
  >
        {(  description.trim().length > 0 || postImage.length > 0) && (

    <a
      onClick={() => {
        handleactiveIconClick('preview');
      }}
    >
      See Preview
    </a>
        )}
  </div>
)}



</div>



           
          </div>

       
      </div>
  
       </div>
       <div>
      {(activeForm === 'preview' || activeForm === 'image') && (
        <div
          className={`col-sm-12 text-center hero-search-wrap-preview-image mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}
        >
          <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
          <div  >
            <label  style={{ color: 'black',fontSize:'17px',fontWeight:'500px' }}>
            Preview
</label>

            <label className=" p-2 pt-1" style={{ color: 'gray',fontSize:'12px' }}>
  Preview shows how your content will look when published on veedu app feed.
  
</label>

          </div>
<hr></hr>

          <div>
          {(activeForm === 'preview' || activeForm === 'image') && (              <div>
               
            <Col md={12} xs={12} className="d-flex align-items-center p-2">
  <img src={profileImageUrl} height="60" width="60" style={{ borderRadius: '50%' }} />
  
  <div className="mx-2">
    <div className="d-flex align-items-center mb-1">
      <h6 className="m-0 me-2">{name}</h6>
      <span
                                                className="mx-1"
                                                style={{ cursor: "pointer" }}
                                            
                                            >
                                                <button
                                                    style={{
                                                        borderRadius: "8px",
                                                       
                                                        border: "1px solid lightgrey",
                                                        background: "#f7f2f266",
                                                        cursor: "pointer",

                                                    }}
                                                >
                                                    <img
            src={paper} 
            alt="Paper"
            style={{ width: '18px', height: '18px' }} 
        />
                                                    <span className="mx-1" style={{ color: "#0a70dd", fontSize: "12px",fontWeight:'bold' }}>Chat</span> 
                                                </button>
                                            </span>    </div>
                                            <div className="d-flex align-items-center mb-1">

  <span 
    className="mx-1" 
    style={{ color: "#0a70dd", fontSize: "12px", fontWeight: 'bold', cursor: 'pointer' }} 
   
  >
   
   
      <span 
        style={{
          color: "#0a70dd", 
          fontSize: "12px", 
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        Follow
      </span>
   
  </span>

    {selectedLocation && selectedLocation.length > 0 && (
      <p className="m-0 d-flex align-items-center">
        <LocationOnIcon className="location_icon_size" />
        <span className="ms-2">{selectedLocation[0]?.name}</span>
      </p>
    )}
    </div>
  </div>
</Col>

            <div className="d-flex align-items-start p-2">
  {description}
</div>

           

            <div className="mt-1">
            {postImage.length > 0 && (         
    <Carousel interval={null}>
      {postImage.map((postImg, index) => (
        <Carousel.Item key={'post_image_' + index}>
          <div className="position-relative d-flex justify-content-center">
            {postImg.type === 'image' ? (
              <img
                src={postImg.imagePath}
                alt={`Slide ${index}`}
                style={{
                  width: '100%',
                  height: '300px',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <div style={{ position: 'relative' }}>
                <video
                  style={{ width: '100%', height: '300px', objectFit: 'cover' }}
                  controls
                >
                  <source src={postImg.videoPath} type={postImg.file.type} />
                </video>
                <div
                  className="d-flex align-items-center justify-content-center video-play-icon"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <PlayCircleOutlineIcon style={{ fontSize: '40px', color: '#fff' }} />
                </div>
              </div>
            )}

       
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
            )}  
  </div>
  <hr />

  <div>
                                    <Col className="d-flex justify-content-evenly">
                                        <div className="col-sm-4 d-flex justify-content-center">
                                            <span className="d-flex align-items-center"
                                                style={{ cursor: 'pointer', color:  'black' }}
                                         
                                            >
                                                <ThumbUpOffAltIcon />
                                                Like
                                              
                                            </span>
                                        </div>
                                        <div className="col-sm-4 d-flex justify-content-center">
                                            <span className="d-flex align-items-center"
                                                style={{ cursor: 'pointer' }}
                                               >
                                                <ChatBubbleOutlineOutlinedIcon />
                                                Comment
                                            </span>
                                        </div>
                                        <div className="col-sm-4 d-flex justify-content-center">
                                            <span className="d-flex align-items-center" style={{ cursor: 'pointer' }}
                                              >
                                                <ShareIcon /> Share
                                            </span>
                                        </div>
                                    </Col>
                                    <hr />
                                </div>

              </div>
            )}
          </div>
        </div>
      )}
    </div>
  
       <div>
      {(activeForm === 'Add Image/video' || activeForm === 'image') && (
        <div
          className={`col-sm-12 text-center hero-search-wrap-post-image mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}
        >
          <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
<hr></hr>
          <div>
          {(activeForm === 'Add Image/video' || activeForm === 'image') && (              <div>
                <input
                  type="file"
                  className="visually-hidden"
                  onChange={onProfessionalPageUploadPostListener}
                  multiple
                  accept="image/*,video/*"
                  id="fileInput"
                />

                {postImage.length === 0 && (
                  <div className="flex items-center" style={{ cursor: 'pointer' }}>
                    <div className="Add-photo text-center mx-auto">
                      <label
                        htmlFor="fileInput"
                        className="add-icon-container"
                        style={{
                          fontWeight: '500',
                          fontSize: '16px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPlusCircle}
                          size="lg"
                          style={{ color: '#d47e8d', cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '15px', color: '#d47e8d' }}>Add pics</span>
                      </label>
                    </div>
                  </div>
                )}

<div className="mt-2 image-grid">
  {postImage.map((postImg, index) => (
    <div
      key={'post_image_' + index}
      className="Add-photo"
      style={{
        margin: '10px',
        position: 'relative',
      }}
      draggable
      onDragStart={(e) => handleDragStart(e, index)}
      onDrop={(e) => handleDrop(e, index)}
      onDragOver={handleDragOver}
    >
      <div
        className="remove-icon"
        style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          cursor: 'pointer',
          color: 'red',
          fontSize: '20px',
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent click from reaching video
          clearCoverImage(index);
        }}
      >
        <FontAwesomeIcon icon={faTimesCircle} />
      </div>

      <div
        className="image-index"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: '#fff',
          padding: '2px 6px',
          borderRadius: '5px',
          fontSize: '20px',
          fontWeight: 'bold',
        }}
      >
        {index + 1}
      </div>

      <div className="col-sm-12 d-flex align-items-center justify-content-center">
        {postImg.type === 'image' ? (
          <img
            src={postImg.imagePath}
            alt="Uploaded"
            style={{
              width: '100%',
              height: '150px',
              objectFit: 'cover',
            }}
          />
        ) : (
          <>
            <video style={{ width: '100%', height: '150px', objectFit: 'cover' }} controls>
              <source src={postImg.videoPath} type={postImg.file.type} />
            </video>
            <div
        className="remove-icon"
        style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          cursor: 'pointer',
          color: 'red',
          fontSize: '20px',
        }}
        onClick={(e) => {
          clearCoverImage(index);
        }}
      >
        <FontAwesomeIcon icon={faTimesCircle} />
      </div>
            <div className="d-flex align-items-center justify-content-center video-play-icon">
              <PlayCircleOutlineIcon style={{ fontSize: '40px', color: '#fff' }} />
            </div>
          </>
        )}
      </div>
    </div>
  ))}

  {postImage.length > 0 && (
    <div className="Add-photo text-center mt-2 mx-2">
      <label
        htmlFor="fileInput"
        className="add-icon-container"
        style={{
          fontWeight: '500',
          fontSize: '16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <FontAwesomeIcon
          icon={faPlusCircle}
          size="lg"
          style={{ color: '#d47e8d', cursor: 'pointer' }}
        />
        <span style={{ fontSize: '15px', color: '#d47e8d' }}>Add pics</span>
      </label>
    </div>
  )}
</div>

              </div>
            )}
          </div>
        </div>
      )}
    </div>

       {activeForm === 'Add Location' && (
       <div className={`col-sm-12 text-center hero-search-wrap-posts mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}>
                 <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
           <hr></hr>  
 
           <div>
   

 
             
               
                 <Col >
                   <div>
                     <Row >
                       <Col xs="auto" className="close-icon">
                      
                       </Col>
                       <Col>
                       <div className={`post-input-field`}>
       
                       <AsyncTypeahead 
                                className="pe-5"
                                labelKey="formatedLocationData"

                                onSearch={searchLocation}
                           options={locationData}
                           onChange={onLocationSelected}
                           useCache={false}
                           placeholder=" "
                           defaultSelected={selectedLocation}
                           isLoading={locationSearchLoading}
                           selected={selectedLocation}
                           renderMenuItemChildren={renderMenuItemChildren}
                                />
                            <span className="fw-bold post-input-field-placeholder mx-2">Where are you</span>
                            <span className="password-toggle-icon px-2"
                                style={{ color: "#aaa" }}>
                            </span>
                        </div>
                      
                       </Col>
                     </Row>
                     <FormFieldError errorMessage={locationValidationErrorMsg}></FormFieldError>
                   </div>
                   {selectedLocation.length > 0 && (
                     <div className="below-text mt-3 m-0">
                       <button onClick={clearSelectedLocation} className="btn btn-danger rounded-pill" type="button">
                         Clear
                       </button>
                     </div>
                   )}
                 </Col>
           
 

          </div>
         </div>
       )}    
        {activeForm === 'Add Tag' && (
       <div className={`col-sm-12 text-center hero-search-wrap-post-tag mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}>
                <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
           <hr></hr>
 
           <div>
   
           <div className="row mt-3">
        <Col className=" text-center">
            <div className="tag-container">
                {tags.map(tag => (
                    <div key={tag} className="tag" style={hoveredTag === tag ? { border: '#ff5c5c solid 3px' } : {}}>
                        <span className="tag-text">{tag}</span>
                        <button className="tag-remove-btn px-1"
                            onMouseEnter={() => setHoveredTag(tag)}
                            onMouseLeave={() => setHoveredTag(null)}
                            onClick={() => removeTag(tag)}>X</button>
                    </div>
                ))}
            </div>
            <div className={`post-input-field `}>
       
                            <input
                                className="pe-5"
                                type= "text" 
                                placeholder=" "
                                value={tagInput}
                                onChange={handleInputChange}
                                onKeyPress={handleInputKeyPress}
                                list="ctaOptions"
                                />
                            <span className="fw-bold post-input-field-placeholder mx-2">Add tags and press Enter</span>
                            <span className="password-toggle-icon px-2"
                                style={{ color: "#aaa" }}>
                            </span>
                        </div>
            <datalist id="ctaOptions" style={{ maxHeight: '20px' }}>
                {postTagsTemplateData && postTagsTemplateData.map((tagData) => (
                    <option key={tagData.id} value={tagData.tagName} />
                ))}
            </datalist>
            <button className="btn btn-primary mt-2 rounded-pill" onClick={addTag}>Add</button>
        </Col>
    </div>
 
             
               
              
           
 

          </div>
         </div>
       )}    
            {activeForm === 'Add YouTube Video' && (
       <div className={`col-sm-12 text-center hero-search-wrap-post-tag mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}>
              <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
           <hr></hr>
 
           <div>
           <Row className="mt-3">
                                        <Col className="mb-2 text-center">
                                            <div className={`post-input-field mt-2`} >
       
       <input
           className="pe-5"
           type= "text" 
           placeholder=" "
           value={youtubeUrl}
           onChange={e => { handleYoutubeURLOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">Enter Url</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                        </Col>
                                    </Row>
             
               
              
           
 

          </div>
         </div>
       )}
            {activeForm === 'Add WhatsApp' && (
       <div className={`col-sm-12 text-center hero-search-wrap-post-tag mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}>
              <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
           <hr></hr>
 
           <div>
           <Row className="mt-3">
                                        <Col className="mb-2 text-center">
                                            <div className={`post-input-field mt-2`} >
       
       <input
           className="pe-5"
           type= "text" 
           placeholder=" "
           value={whatsAppNumber}
           onChange={e => { handleWhatsAppNumberOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">Enter WhatsApp Number to chat url</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
                                           
                                        </Col>
                                    </Row>
             
               
              
           
 

          </div>
         </div>
       )}
          {activeForm === 'Add calltoAction' && (
       <div className={`col-sm-12 text-center hero-search-wrap-post-action mt-3 ${showPostForm ? 'slide-right-post' : 'hide'}`}>
           <div className="d-flex justify-content-start p-2">
          <Tooltip title="Back" arrow>
      <div
        onClick={togglePostForm}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          padding: '8px',
          cursor: 'pointer',
          transition: 'background 0.3s',
          backgroundColor: hover ? '#e0e0e0' : 'transparent',
        }}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'black', fontSize: '18px' }}
        />
      </div>
          </Tooltip>

                         <label className="go-back-label mt-1 mx-2">Go back to publish</label>

          </div>
           <hr></hr>
 
           <div>
           <Row className="mt-3 ">
  <div className="col-12">

  <div className={`post-input-field mt-4 `} >
        
       
    <select
               className="pe-5"

      value={callToActionIdStr}
      onChange={(e) => handleCallToActionChange(e.target.value)}
    >
      {showCallToActionOption && <option>Select</option>}
      {callToActionData && callToActionData.map((ctaData: any, index: any) => (
        <option className="text-edit" key={ctaData.id} value={ctaData.id}>
          {ctaData.label}
        </option>
      ))}
    </select>
       <span className="fw-bold post-input-field-placeholder mx-2">CallToAction</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
    
    <FormFieldError errorMessage={callToActionValidationErrorMsg}></FormFieldError>
  </div>

  <div className="col-12">
  <div className={`post-input-field mt-4 `} >
       
       <input
                  className="pe-5"

      type= "text" 
           placeholder=" "
           value={callToActionUrl}
           onChange={e => { handlecallToActionUrlOnChange(e.target.value) }}
           />
       <span className="fw-bold post-input-field-placeholder mx-2">CallToActionUrl</span>
       <span className="password-toggle-icon px-2"
           style={{ color: "#aaa" }}>
       </span>
   </div>
   
    <FormFieldError errorMessage={callToActionUrlValidationErrorMsg}></FormFieldError>
  </div>
</Row>
             
               
              
           
 

          </div>
         </div>
       )}  
       </div>
         
         
        </div>
        <Modal show={showPurchaseTagDialog} centered backdrop="static" className="purchase-tag-dialog-modal"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
            <Modal.Header className="border-0 justify-content-center position-relative">
                <Button variant="link" className="p-0 purchase-tag-back-icon" onClick={handleClosePurchaseTagDialog}>
                    <ArrowBackIcon />
                </Button>
                <Modal.Title className="text-center font-weight-bold text-uppercase">
                    Purchase Tag
                </Modal.Title>
                <Button variant="link" className="p-0 purchase-tag-close-icon" onClick={handleClosePurchaseTagDialog}>
                    <CloseIcon />
                </Button>
            </Modal.Header>
            <Modal.Body className="p-4 pb-0">
                <div className="d-flex justify-content-between mb-3 align-items-center">
                    {!showTagSearchBox ? (
                        <Button variant="primary" className="purchase-tag-add-tag-button" onClick={() => setShowTagSearchBox(true)}>
                            + Add Tag
                        </Button>
                    ) : (
                        <div className="d-flex align-items-center purchase-tag-search-box-container">
                            <AsyncTypeahead
                                className="tag-search-purchase-dialog"
                                id="tag-search"
                                ref={typeaheadRef}
                                labelKey="tagName"
                                onSearch={searchTagToPurchase}
                                options={searchedTagData}
                                onChange={handleSearchedTagSelected}
                                useCache={false}
                                placeholder="Search Tags"
                                isLoading={tagSearchLoading}
                            />
                            <Button variant="link" className="p-0 purchase-tag-close-search-icon" onClick={() => setShowTagSearchBox(false)}>
                                <CloseIcon />
                            </Button>
                        </div>
                    )}
                    <Form.Check
                        id="selectAllCheckbox"
                        type="checkbox"
                        label="Select All"
                        checked={selectAllTagsToPurchase}
                        onChange={handleSelectAllTagsToPurchaseChange}
                    />
                </div>
                <div className="switch-account-scrollbar" style={{ maxHeight: '65vh', overflow: 'auto' }}>
                    {unPurchasedTagData.map((tagItem, index) => (
                        <Card className="m-2 shadow-lg purchase-tag-card-modern" key={index}
                            onClick={() => handleCheckboxChange(index, !selectedTagsToPurchase.includes(index))}
                        >
                            <Card.Body className="d-flex justify-content-between align-items-center p-3">
                                <Form.Check type="checkbox" className="me-3 purchase-tag-custom-checkbox"
                                    checked={selectedTagsToPurchase.includes(index)}
                                    onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                                    onClick={(e) => e.stopPropagation()} />
                                <div className="purchase-tag-info">
                                    <span className="purchase-tag-name d-block"
                                        style={{ wordBreak: 'break-word' }}>{tagItem.tagName}</span>
                                    <span
                                        className={`small ${alreadyPurchasedTagData.some(data => data.id === tagItem.id) ? 'text-warning' : tagItem.monthlyTagCost <= 0 ? 'text-success' : 'text-danger'}`}
                                        style={{ fontWeight: "bold" }}>
                                        {alreadyPurchasedTagData.some(data => data.id === tagItem.id) ? 'Purchased' : tagItem.monthlyTagCost <= 0 ? 'Free' : 'Premium'}
                                    </span>
                                </div>
                                <div className="purchase-tag-cost-final text-primary font-weight-bold"
                                    style={{ wordBreak: 'break-word' }}>
                                    {alreadyPurchasedTagData.some(data => data.id === tagItem.id) ? (
                                        <>
                                            <span className="crossed-out-cost">₹{paymentPeriod === 'MONTHLY'
                                                ? tagItem.monthlyTagCost
                                                : tagItem.yearlyTagCost > 0
                                                    ? tagItem.yearlyTagCost
                                                    : tagItem.monthlyTagCost * 10}
                                            </span>
                                            <span className="text-primary ms-2">₹0</span>
                                        </>
                                    ) : (
                                        `₹${paymentPeriod === 'MONTHLY'
                                            ? tagItem.monthlyTagCost
                                            : tagItem.yearlyTagCost > 0
                                                ? tagItem.yearlyTagCost
                                                : tagItem.monthlyTagCost * 10}`
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    ))}
                </div>
                <div className="d-flex justify-content-center align-items-center mt-3 px-3">
                    {!showCodeAppliedText &&
                        <p>Have any PromoCode ? <a className="d-block d-sm-inline-block text-sm-left text-danger text-center"
                            onClick={() => setShowApplyPromoCodePopUp(true)}
                            style={{ cursor: 'pointer' }}> apply</a>
                        </p>
                    }
                    {showCodeAppliedText &&
                        <p className="green-text">Promo Code Applied !</p>
                    }
                </div>
                <div className="d-flex justify-content-end align-items-center px-3">
                    <Form.Check
                        id="selectMonthlyRadio"
                        type="radio"
                        label="Monthly"
                        name="paymentPeriod"
                        className="me-3"
                        checked={paymentPeriod === 'MONTHLY'}
                        onChange={() => setPaymentPeriod('MONTHLY')}
                    />
                    <Form.Check
                        id="selectYearlylyRadio"
                        type="radio"
                        label="Yearly"
                        name="paymentPeriod"
                        checked={paymentPeriod === 'YEARLY'}
                        onChange={() => setPaymentPeriod('YEARLY')}
                    />
                </div>
                <div className="d-flex flex-column mt-3 purchase-tag-total-section p-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h4 className="fw-bold text-uppercase m-0 text-secondary">Total Amount:</h4>
                        <h4 className="purchase-tag-total-cost text-success fw-bold m-0">₹{totalCost.toFixed(2)}</h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h4 className="fw-bold text-uppercase m-0 text-secondary">Tax ({taxPercentage.taxPercentage}%):</h4>
                        <h4 className="purchase-tag-tax-cost text-danger fw-bold m-0">₹{taxAmount}</h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h5 className="fw-bold text-uppercase m-0">Grand Total:</h5>
                        <h5 className="purchase-tag-grand-total-cost text-primary fw-bold m-0">₹{grandTotal}</h5>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 d-flex justify-content-between"
                style={{ flexWrap: 'nowrap' }}>
                <Button variant="secondary" className="w-50 py-3 purchase-tag-cancel-button"
                    onClick={handleClosePurchaseTagDialog}>
                    Cancel
                </Button>
                <Button variant="primary" className="w-50 py-3 purchase-tag-pay-button"
                    onClick={handlePay}
                    disabled={selectedTagsToPurchase.length === 0}>
                    Pay Now
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal show={showAlertDialog} onHide={handleAlertNo} centered backdrop="static"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
            <Modal.Header closeButton className="purchase-tag-alert-header">
                <Modal.Title className="purchase-tag-alert-title">Confirm Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body className="purchase-tag-alert-body">
                Are you sure you want to cancel? The tag will not be added to your post.
            </Modal.Body>
            <Modal.Footer className="purchase-tag-alert-footer">
                <Button className="purchase-tag-alert-button-no" onClick={handleAlertNo}>
                    No
                </Button>
                <Button className="purchase-tag-alert-button-yes" onClick={handleAlertYes}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal size="lg" show={showApplyPromoCodePopUp} onHide={() => setShowApplyPromoCodePopUp(false)} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Verify Your Promo Code</Modal.Title>
            </Modal.Header>
            <div >
                <div className="modal-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-2 mt-2">
                                    <label>Promo Code :</label>
                                </div>
                                <div className="col-sm-4">
                                    <input type="text" className={`input-value form-control ${promoCodeValidationError ? 'is-invalid' : ''}`}
                                        value={promoCodeText} onChange={(e) => { handlePromoCodeChange(e.target.value) }}
                                        placeholder="Enter your code" name="firstName" />
                                    <i className="ti-user"></i>
                                    {promoCodeValidationError && <div className="invalid-feedback"> Promo code required</div>}
                                </div>
                                <div className="col-sm-3 mt-1">
                                    {!verifyCodeProcess && <button className="btn btn-success" type="button"
                                        onClick={getPromoCodeByCode}> verify</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {verifyCodeProcess && <div className="modal-body">
                <div className="row">
                    <div className="row">
                        <div className="col-sm-2 mt-2">
                            <label>You will get </label>
                        </div>
                        <div className="col-sm-3">
                            <label>{promoCode.discountAmount}</label>
                        </div>
                        <div className="col-sm-3 mt-1">
                            <button className="btn btn-success" type="button" onClick={applyPromoCode}>apply</button>
                        </div>
                    </div>
                </div>
            </div>}
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowApplyPromoCodePopUp(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <form
            id="sabPaisaForm"
            action={sabpaisaUrl}
            method="post"
            style={{ display: 'none' }}>
            <input type="text" name="encData" value={encData} />
            <input type="text" name="clientCode" value={clientCode} />
        </form>
    </>
}

export default AddProfessionPost;